import { render, staticRenderFns } from "./product-display-list.vue?vue&type=template&id=a0e3b2c4&"
import script from "./product-display-list.vue?vue&type=script&lang=js&"
export * from "./product-display-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports